import { useState } from 'react';
import { ToolT03Icon } from '@/icons';
import { useActiveTool } from '@/store/store';
import { numericPart } from '@/components/ToolsPage/toolData';
import { SpindleMeter } from '@/components/jog/SpindleMeter';
import { OverridePanel } from '@/components/jog/OverridePanel';
import { JogControls } from '@/components/jog/JogControls';
import { AxisDiagram } from '@/components/jog/AxisDiagram';
import { RotaryControls } from '@/components/jog/RotaryControls';
import { JogSelectors } from '@/components/jog/JogSelectors';
import { MDIPanel } from '@/components/jog/MDIPanel';
import styles from '@/components/jog/jog.module.css';

export function JogPanel(): JSX.Element {
  const [mode, setMode] = useState<'jog' | 'mdi'>('jog');
  const activeTool = useActiveTool();
  const dia = activeTool ? numericPart(activeTool.diameter) : '';

  return (
    <div className={styles.jogPanel} role="region" aria-label="Jog Controls">
      {/* Header: Jog / MDI toggle + tool badge */}
      <div className={styles.jogHeader}>
        <div className={styles.jogModeToggle}>
          <button
            className={`${styles.jogModeTab} ${mode === 'jog' ? styles.jogModeTabActive : ''}`}
            onClick={() => setMode('jog')}
            type="button"
          >
            Jog
          </button>
          <button
            className={`${styles.jogModeTab} ${mode === 'mdi' ? styles.jogModeTabActive : ''}`}
            onClick={() => setMode('mdi')}
            type="button"
          >
            MDI
          </button>
        </div>

        <div className={styles.jogToolBadge} aria-label="Active tool">
          <ToolT03Icon width={40} height={40} />
          <div className={styles.jogToolInfo}>
            <span className={styles.jogToolName}>Tool : {activeTool ? activeTool.no : '—'}</span>
          </div>
          <div>
            <span className={styles.jogToolDesc}>
              {activeTool && activeTool.type
                ? `${activeTool.type}${dia ? ` ${dia}mm` : ''}`
                : 'No tool called'}
            </span>
          </div>
        </div>
      </div>

      {mode === 'jog' ? (
        /* Body: two columns */
        <div className={styles.jogBody}>
          {/* Left column: spindle meter + override sliders */}
          <div className={styles.jogColLeft}>
            <SpindleMeter />
            <OverridePanel />
          </div>

          {/* Right column: machine diagram → jog pad → rotary → step/feed */}
          <div className={`${styles.jogCard} ${styles.jogColRight}`}>
            <AxisDiagram />
            <hr className={styles.jogCardDivider} />
            <JogControls />
            <RotaryControls />
            <hr className={styles.jogCardDivider} />
            <JogSelectors />
          </div>
        </div>
      ) : (
        <MDIPanel />
      )}
    </div>
  );
}
